import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './index.css';

const propTypes = {
  until: PropTypes.string.isRequired,
};

const MaintenancePage = ({ until }) => {
  const momentMaintenanceUntil = moment(until);

  return (
    <div className="MaintenancePage">
      <h1>Os servidores do Chama estão em manutenção.</h1>
      {momentMaintenanceUntil.isValid() && (
        <div>
          Hora prevista para volta: <strong>{momentMaintenanceUntil.format('HH:mm')}</strong>
        </div>
      )}
      <br />
      <div>Desculpe-nos pelo transtorno.</div>
    </div>
  );
};

MaintenancePage.propTypes = propTypes;

export default MaintenancePage;



// WEBPACK FOOTER //
// ../ui-components/components/MaintenancePage/index.jsx